import React from "react";
import { useNavigate } from "react-router-dom";
import { X } from "lucide-react";
import AccountPage from "@/pages/Account";

export default function AccountModal() {
  const navigate = useNavigate();
  const close = () => { if (window.history.length > 2) navigate(-1); else navigate("/app"); };
  return (
    <div data-testid="account-modal" onMouseDown={close} className="fixed inset-0 z-[60] flex items-center justify-center bg-black/60 p-3 backdrop-blur-md md:p-6">
      <div onMouseDown={(e) => e.stopPropagation()} className="relative flex h-[90vh] max-h-[90vh] w-full max-w-3xl flex-col overflow-hidden rounded-3xl border border-zinc-800 bg-zinc-950 p-5 shadow-2xl md:p-7">
        <button data-testid="account-modal-close" onClick={close} className="absolute right-4 top-4 z-10 rounded-full p-2 text-zinc-400 transition-colors hover:bg-zinc-800 hover:text-white" title="Fermer">
          <X className="h-5 w-5" />
        </button>
        <div className="min-h-0 flex-1 overflow-y-auto pr-1">
          <AccountPage />
        </div>
      </div>
    </div>
  );
}
